import React from "react";

const VaccinesIcon= () => {
  return (
     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.25 13.75L7.49365 12.5063" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.5112 7.21606L7.24112 10.4861C7.0067 10.7205 6.875 11.0385 6.875 11.37C6.875 11.7015 7.0067 12.0195 7.24112 12.2539L7.74619 12.759C8.23436 13.2471 9.0258 13.2471 9.51397 12.759L12.784 9.48891" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="2.5" y="2.5" width="15" height="15" rx="5" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.3346 6.66675L11.668 8.33341" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 6.66675L13.3333 10.0001" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.1667 7.49992L12.5 5.83325" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>
    );
};
export default VaccinesIcon;